<!-- views/WechatCallback.vue -->
<template>
  <div style="text-align: center; padding: 40px;">
    <p v-if="processing">微信登录成功，正在处理...</p>
    <p v-else-if="error">{{ error }}</p>
  </div>
</template>

<script>
import config from "../../config/config";

export default {
  name: 'WechatCallback',
  data() {
    return {
      processing: true,
      error: ''
    };
  },
  mounted() {
    this.handleCallback();
  },
  methods: {
    async handleCallback() {
      // 1. 解析 URL 参数
      let queryParams = window.location.search;
      if (!queryParams && window.location.hash.includes('?')) {
        const hashParts = window.location.hash.split('?');
        if (hashParts.length > 1) {
          queryParams = '?' + hashParts[1];
        }
      }
      const urlParams = new URLSearchParams(queryParams);
      const code = urlParams.get('code');

      if (!code) {
        this.error = '授权失败，缺少code参数';
        this.processing = false;
        return;
      }

      // 2. 有 opener 就发 postMessage（弹窗回调场景）
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(
          { type: 'WECHAT_LOGIN_REDIRECT', data: { code } },
          '*'
        );
        setTimeout(() => window.close(), 1500);
        return;
      }

      // 3. 没有 opener，直接调后端接口（新标签页回调场景）
      try {
        const res = await fetch(config.BASE_URL + '/wechat/callback?code=' + code);
        const json = await res.json();
        if (json.code === 10000) {
          // 把 token 存到 sessionStorage，主页面拿得到
          sessionStorage.setItem('wechat_login_token', json.data.token);
          sessionStorage.setItem('wechat_login_user', JSON.stringify(json.data.user));
          // 跳回首页
          window.location.replace('/');
        } else {
          this.error = json.message || '登录失败';
          this.processing = false;
        }
      } catch (e) {
        console.error('微信回调请求失败:', e);
        this.error = '网络异常，请重试';
        this.processing = false;
      }
    }
  }
};
</script>
